module.exports = __webpack_public_path__ + "static/media/instructivosc1.43281f83.png";